// src/components/AfterVideoSection.tsx
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Link,
  ListItemText,
  Rating,
  Stack,
  Typography,
  alpha,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
//import { useInView } from "react-intersection-observer";
//import SignUpForm from "./SignUpForm";
import Carousel from "./Carousel";
import HowCarousel from "./HowCarousel";
import SoftCapDMAI from "./SoftCapDMAI";
import TheWhy from "./TheWhy";
import { FadeInView } from "./common/FadeInView";
import { FadeInView2 } from "./common/FadeInView2";
import { FadeInView3 } from "./common/FadeInView3";
import { CheckCircleOutlineOutlined } from "@mui/icons-material";

interface AfterVideoSectionProps {
  launched: boolean;
}

const AfterVideoSection: React.FC<AfterVideoSectionProps> = ({ launched }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const stopConfetti = () => setShowConfetti(false);

    if (showConfetti) {
      window.addEventListener("click", stopConfetti);
    }

    return () => {
      window.removeEventListener("click", stopConfetti);
    };
  }, [showConfetti]);

  /*
  const BlurredOverlay1 = styled(Box)({
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: "78%", // Cover only 50% of the image
    backdropFilter: "blur(3px)", // Apply the blur effect directly on the overlay
    overflow: "hidden",
  });

  const BlurredOverlay2 = styled(Box)({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    width: "22%", // Cover only 50% of the image
    backdropFilter: "blur(3px)", // Apply the blur effect directly on the overlay
    overflow: "hidden",
  });
*/
  const features = [
    {
      title: "Workflow automation & data structuring",
      description:
        "Streamlines the investment banking journey from idea to completion, centralizing communication, tasks, and documents on one platform, while organizing data for one-click document creation",
    },
    {
      title: "Real-Time updates & speed to market",
      description:
        "Reduces time spent on project work and quality control, freeing up resources for more strategic tasks. Thus accelerates client interactions for faster market responsiveness",
    },
    {
      title: "Microsoft 365 integration & unified project view",
      description:
        "Offers seamless access within the Microsoft ecosystem and centralizes information for efficient collaboration and workflow coordination",
    },

    {
      title: "Improved deal throughput",
      description:
        "Achieve a higher win rate through more effective deal management and execution",
    },
    {
      title: "Efficiency & AI enhancement",
      description:
        "Leverages AI for efficiency in project management and workflow automation",
    },
  ];

  const quotes = [
    `“Today, over 50% of time spent is an internal logistics and information gathering process before you can work on what leads to value. DealMaker AI will solve a lot of painpoints”`,
    `“This solution will be a killer product. The problems we experience should have been solved at least 15 years ago”`,
    `“The closest we have to workflow optimization tools is a CRM system which is a reporting tool. I do not use it in my daily workflow”`,
    `“This solution is exactly what I've envisioned for years”`,
  ];

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        //padding: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Adjusted for overall alignment
        justifyContent: "center", // Adjusted for vertical alignment
        width: "100%", // Full width
        maxWidth: "1300px", // Maximum width
        marginLeft: "auto", // Centering horizontally
        marginRight: "auto", // Centering horizontally
        padding: "0 23px 0 23px",
        //marginTop: isMobile ? -8 : -13,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left", // Adjusted for overall alignment
          justifyContent: "center", // Adjusted for vertical alignment
          width: "100%", // Full width
          //height: "300px",
        }}
      ></Box>

      {launched && (
        <>
          {/*
          <Grid container spacing={2} sx={{ mt: "15vh", marginBottom: 3 }}>
            <Grid item xs={3} sm={3} md={3}>
              <FadeInView3 delay={10}>
                <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                  <Box>
                    <Typography
                      variant={isMobile ? "h6" : "h5"}
                      sx={{
                        textAlign: "center",
                        color: "#e6e6e6",
                      }}
                      component="div"
                      gutterBottom
                    >
                      Summary
                    </Typography>

                    <Card
                      variant="outlined"
                      sx={{
                        maxWidth: 600,
                        //minHeight: 250,
                        width: "100%",
                        //marginBottom: 2,
                        backgroundColor: "#12181f", // Custom background color
                        border: "1px solid #30363d", // Custom border color
                        color: "text.primary", // Ensures text color is from the theme
                      }}
                    >
                      <CardContent>
                        {" "}
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{
                            color: "text.secondary",
                          }} // Adjust the styling as needed
                          component="div"
                          gutterBottom
                        >
                          Link + one liner or picture/ text explaining.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Tilt>
              </FadeInView3>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FadeInView3 delay={60}>
                <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                  <Box>
                    <Typography
                      variant={isMobile ? "h6" : "h5"}
                      sx={{
                        textAlign: "center",
                        color: "#e6e6e6",
                      }}
                      component="div"
                      gutterBottom
                    >
                      Problem
                    </Typography>

                    <Card
                      variant="outlined"
                      sx={{
                        //maxWidth: 600,
                        //minHeight: 250,
                        width: "100%",
                        //marginBottom: 2,
                        backgroundColor: "#12181f", // Custom background color
                        border: "1px solid #30363d", // Custom border color
                        color: "text.primary", // Ensures text color is from the theme
                      }}
                    >
                      <CardContent>
                        {" "}
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{
                            color: "text.secondary",
                          }} // Adjust the styling as needed
                          component="div"
                          gutterBottom
                        >
                          Link + one liner or picture/ text explaining.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Tilt>
              </FadeInView3>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FadeInView3 delay={90}>
                <Tilt tiltMaxAngleX={4} tiltMaxAngleY={4}>
                  <Box>
                    <Typography
                      variant={isMobile ? "h6" : "h5"}
                      sx={{
                        textAlign: "center",
                        color: "#e6e6e6",
                      }}
                      component="div"
                      gutterBottom
                    >
                      Solution
                    </Typography>

                    <Card
                      variant="outlined"
                      sx={{
                        //maxWidth: 600,
                        //minHeight: 250,
                        width: "100%",
                        //marginBottom: 2,
                        backgroundColor: "#12181f", // Custom background color
                        border: "1px solid #30363d", // Custom border color
                        color: "text.primary", // Ensures text color is from the theme
                      }}
                    >
                      <CardContent>
                        {" "}
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{
                            color: "text.secondary",
                          }} // Adjust the styling as needed
                          component="div"
                          gutterBottom
                        >
                          Link + one liner or picture/ text explaining.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Tilt>
              </FadeInView3>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              <FadeInView3 delay={10}>
                <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                  <Box>
                    <Typography
                      variant={isMobile ? "h6" : "h5"}
                      sx={{
                        textAlign: "center",
                        color: "#e6e6e6",
                      }}
                      component="div"
                      gutterBottom
                    >
                      Next
                    </Typography>

                    <Card
                      variant="outlined"
                      sx={{
                        maxWidth: 600,
                        //minHeight: 250,
                        width: "100%",
                        //marginBottom: 2,
                        backgroundColor: "#12181f", // Custom background color
                        border: "1px solid #30363d", // Custom border color
                        color: "text.primary", // Ensures text color is from the theme
                      }}
                    >
                      <CardContent>
                        {" "}
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{
                            color: "text.secondary",
                          }} // Adjust the styling as needed
                          component="div"
                          gutterBottom
                        >
                          Link + one liner or picture/ text explaining.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Box>
                </Tilt>
              </FadeInView3>
            </Grid>
          </Grid>
                          */}

          {/*
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 6 : 12 }}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView3 delay={30}>
                <Typography
                  variant={isMobile ? "h6" : "h5"}
                  sx={{ textAlign: "center" }}
                >
                  {" "}
                  DealMaker AI{" "}
                </Typography>
              </FadeInView3>
              <FadeInView3 delay={60}>
                <Typography
                  variant={isMobile ? "h4" : "h2"}
                  sx={{
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Streamlining workflow with precision
                </Typography>
              </FadeInView3>

              <FadeInView3 delay={90}>
                <Typography
                  variant={isMobile ? "body1" : "h5"}
                  sx={{
                    textAlign: "center",
                    color: "text.secondary",
                  }}
                >
                  {" "}
                </Typography>
              </FadeInView3>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView2>
                <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                  <Box>
                    <Card
                      variant="outlined"
                      sx={{
                        //maxWidth: 600,
                        //minHeight: 250,
                        width: "100%",
                        //marginBottom: 2,
                        backgroundColor: "#12181f", // Custom background color
                        border: "0px solid #30363d", // Custom border color
                        color: "text.primary", // Ensures text color is from the theme
                        p: 0,
                        m: 0,
                      }}
                    >
                      <img
                        src="wax24-1.png"
                        alt="PowerPoint add-in"
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </Card>
                  </Box>
                </Tilt>
              </FadeInView2>
            </Grid>
          </Grid>
          */}
          {/* ---------------------SECTION 2-----THE -WHY------------------------ */}
          {/* ---------------------START: WHY----------------------- */}
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 6 : 12 }}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView3 delay={30}>
                <Box>
                  <Typography
                    variant={isMobile ? "h4" : "h2"}
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    Collaborate effortlessly in one unified solution
                  </Typography>
                </Box>
              </FadeInView3>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 3 : 3 }}>
            <Grid item xs={12} sm={12} md={12}>
              <Box>
                {/*
                  <Box sx={{ textAlign: "center", mb: 1 }}>
                    <FadeInView3 delay={90}>
                      <Chip
                        label="Challenge"
                        sx={{
                          backgroundColor: "#e65d45",
                          fontSize: "1.2rem",
                          mb: 1,
                          width: "150px",
                        }}
                      />
                    </FadeInView3>
                  </Box>
                  */}
                <FadeInView3 delay={120}>
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{
                      textAlign: "center",
                      color: "#e6e6e6",
                    }}
                    component="div"
                    gutterBottom
                  >
                    {/*
                      Data across multiple apps, channels and repetitive
                      workflows
                      */}
                  </Typography>
                </FadeInView3>
                <Grid
                  container
                  spacing={9}
                  sx={{ marginTop: 3, marginBottom: 3, height: "100%" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    sx={{
                      marginTop: 0,
                      height: "100%",
                      pr: isMobile ? "0" : 0,
                    }}
                  >
                    <FadeInView3 delay={200}>
                      <Card
                        variant="outlined"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%", // This makes the card fill the container height
                          minHeight: isMobile ? "" : 492, // Ensures a minimum height
                          width: "100%",
                          marginBottom: 0,
                          p: isMobile ? 3 : 6,
                          //backgroundColor: "#2f363e",
                          //backgroundColor: "#0d1117",
                          border: "1px solid #30363d",
                          color: "text.primary",
                          position: "relative", // Needed for absolute positioning of the children
                          overflow: "hidden", // Prevents any absolutely positioned child from overflowing

                          alignItems: "center", // Center content vertically in the card
                          justifyContent: "center", // Center content horizontally in the card
                        }}
                      >
                        <Stack
                          direction="column"
                          spacing={2} // Adjust spacing between items
                          alignItems="center" // Centers children horizontally in the stack
                          sx={{
                            width: "100%", // Ensures stack takes full width of its container
                            maxWidth: "lg", // Limits maximum width, adjust as needed
                            mx: "auto", // Centers the stack horizontally in its container
                          }}
                        >
                          <FadeInView3 delay={30}>
                            <Box sx={{ textAlign: "center", mb: 1 }}>
                              <Chip
                                label="CHALLENGE"
                                sx={{
                                  backgroundColor: "#e65d45",
                                  fontSize: "1.2rem",
                                  mb: 1,
                                  width: "250px",
                                }}
                              />
                            </Box>
                          </FadeInView3>
                          <Typography
                            variant={isMobile ? "h6" : "h5"}
                            sx={{ textAlign: "center", mb: 3 }}
                          >
                            {/*
                        Problem: Navigating through the maze of dispersed
                        information
                    */}
                            Disconnected data and workflows spread across apps,
                            channels, files and folders
                          </Typography>
                          <Box
                            sx={{
                              //mt: 29,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center", // Corrected for horizontal centering
                              justifyContent: "center", // Ensures vertical centering
                              width: "60%", // Full width
                              minWidth: 300, // Ensure a minimum width
                              minHeight: 250, // Ensure a minimum height
                              height: "100%", // Full height
                              pl: 2,
                            }}
                          >
                            <TheWhy />
                          </Box>
                        </Stack>
                      </Card>
                    </FadeInView3>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    sx={{
                      marginTop: 0,
                      height: "100%",
                      pr: isMobile ? "0" : 0,
                    }}
                  >
                    <FadeInView3 delay={200}>
                      <Card
                        variant="outlined"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%", // This makes the card fill the container height
                          minHeight: isMobile ? "" : 492, // Ensures a minimum height
                          width: "100%",
                          marginBottom: 0,
                          p: isMobile ? 3 : 6,
                          //backgroundColor: "#2f363e",
                          //backgroundColor: "#0d1117",
                          border: "1px solid #30363d",
                          color: "text.primary",
                          position: "relative", // Needed for absolute positioning of the children
                          overflow: "hidden", // Prevents any absolutely positioned child from overflowing

                          alignItems: "center", // Center content vertically in the card
                          justifyContent: "center", // Center content horizontally in the card
                        }}
                      >
                        <Stack
                          direction="column"
                          spacing={2} // Adjust spacing between items
                          alignItems="center" // Centers children horizontally in the stack
                          sx={{
                            width: "100%", // Ensures stack takes full width of its container
                            maxWidth: "lg", // Limits maximum width, adjust as needed
                            mx: "auto", // Centers the stack horizontally in its container
                          }}
                        >
                          <FadeInView3 delay={30}>
                            <Box sx={{ textAlign: "center", mb: 5 }}>
                              <Chip
                                label="SOLUTION"
                                sx={{
                                  backgroundColor: "#007fff",
                                  fontSize: "1.2rem",
                                  mb: 1,
                                  width: "250px",
                                }}
                              />
                            </Box>
                          </FadeInView3>
                          <Typography
                            variant={isMobile ? "h6" : "h5"}
                            sx={{ textAlign: "center", mb: 3 }}
                          >
                            {/*
                        Problem: Navigating through the maze of dispersed
                        information
                    */}
                            Bring everything together
                            {/*
                            and access data right
                            where you work with DealMaker AI
                            */}
                          </Typography>
                          {/* Background Image */}

                          <Box sx={{ minHeight: 250 }}>
                            <Box
                              sx={{
                                position: "absolute",
                                top: "60%",
                                left: "50%",
                                width: "70%", // Set width to 50% of its parent
                                height: "100%", // Set height to 50% of its parent

                                transform: "translate(-50%, -50%)", // Center the box
                                zIndex: 0, // Ensure the image stays in the background
                                "& img": {
                                  opacity: 0.5,
                                  width: "100%", // Make the image fully occupy the box
                                  height: "100%", // Make the image fully occupy the box
                                  objectFit: "contain", // Ensure the image's aspect ratio is maintained
                                },
                              }}
                            >
                              <img
                                src="pointsolution.png"
                                alt="Back logos"
                                style={{ opacity: 0.3 }}
                              />
                            </Box>

                            {/* SoftCapDMAI Component */}
                            <Box
                              sx={{
                                mt: 7,
                                position: "relative", // This ensures it's positioned above the background
                                zIndex: 1, // Above the image
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%", // Ensure it takes up the full width for centering
                              }}
                            >
                              <SoftCapDMAI />
                            </Box>
                          </Box>
                        </Stack>
                      </Card>
                    </FadeInView3>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: isMobile ? 6 : 21 }}>
            <Grid item xs={12} sm={12} md={12}>
              <Box>
                <FadeInView3 delay={40}>
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{
                      textAlign: "center",
                      color: "#e6e6e6",
                      "& span.marked": {
                        //backgroundColor: "#1f566f",
                        backgroundColor: alpha("rgba(0, 127, 255, 1)", 0.4), // Background color for the marked effect
                        color: "#FFFFFF", // Adjust text color if needed
                        padding: "0 4px", // Adds some padding around the text for better visibility
                      },
                    }}
                    component="div"
                    gutterBottom
                  >
                    <span className="marked">DealMaker AI</span> centralizes
                    project data, workflows, and Microsoft 365 documents into a
                    single platform
                  </Typography>
                </FadeInView3>

                <Grid
                  container
                  spacing={3}
                  sx={{ marginTop: 1, marginBottom: 3, height: "100%" }}
                >
                  <Grid item xs={12} sm={7} md={7}>
                    <FadeInView3 delay={90}>
                      <Card
                        variant="outlined"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%", // This makes the card fill the container height
                          minHeight: isMobile ? "200px" : "510px",
                          width: "100%",
                          marginBottom: 0,
                          p: 0,
                          backgroundColor: "#0d1117",
                          //border: "1px solid #30363d",
                          color: "text.primary",
                          position: "relative", // Needed for absolute positioning of the children
                          overflow: "hidden", // Prevents any absolutely positioned child from overflowing

                          alignItems: "center", // Center content vertically in the card
                          justifyContent: "center", // Center content horizontally in the card
                        }}
                      >
                        {/* Background Image */}
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            width: "100%", // Set width to 50% of its parent
                            height: "100%", // Set height to 50% of its parent
                            transform: "translate(-50%, -50%)", // Center the box
                            zIndex: 0, // Ensure the image stays in the background
                            "& img": {
                              opacity: 1.5,
                              width: "100%", // Make the image fully occupy the box
                              height: "100%", // Make the image fully occupy the box
                              objectFit: "contain", // Ensure the image's aspect ratio is maintained
                            },
                          }}
                        >
                          <img
                            src="wax24-1.png"
                            alt="Back logos"
                            style={{ opacity: 1 }}
                          />
                        </Box>

                        {/* SoftCapDMAI Component */}
                      </Card>
                    </FadeInView3>
                  </Grid>
                  <Grid item xs={12} sm={5} md={5}>
                    <FadeInView3 delay={120}>
                      <Card
                        variant="outlined"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%", // Match the height of the sibling card
                          minHeight: isMobile ? "300px" : "510px",
                          width: "100%",

                          //backgroundColor: "#0d1117",
                          border: "1px solid #30363d",
                          color: "text.primary",
                          overflow: "hidden", // This prevents content from overflowing
                        }}
                      >
                        <CardContent
                          sx={{
                            pt: 3,
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "left",
                          }}
                        >
                          <Typography
                            variant={isMobile ? "body1" : "h6"}
                            sx={{
                              textAlign: "left", // For horizontal centering; change to "justify" or "left" if needed
                              color: "#fff",
                              width: "100%", // Take full width to maintain text alignment control
                            }}
                            component="div"
                            gutterBottom
                          >
                            In the fast-paced world of investment banking,
                            professionals are constantly juggling the demands of
                            delivering persuasive client pitches within tight
                            deadlines and managing a multitude of projects with
                            precision.
                            <br />
                            <br />
                            <span style={{ color: "#007fff" }}>
                              Our solution{" "}
                            </span>
                            transforms workflows by seamlessly integrating
                            tasks, meetings, and documents into a unified
                            project system.
                            <br />
                            <br />
                            Leverage Microsoft 365 integration and add-ins,
                            offering real-time situational awareness and a
                            comprehensive project overview for enhanced team
                            coordination and efficiency. Streamline document
                            production and harness the power of AI to transform
                            your workflow.
                          </Typography>
                        </CardContent>
                      </Card>
                    </FadeInView3>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {/* ---------------------END SECTION 2-----THE -WHY------------------------ */}
          {/* ---------------------SECTION 3------SOLUTION------------------------ */}
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 6 : 21 }}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView2>
                <Box sx={{ p: 0 }}>
                  <Typography
                    variant={isMobile ? "h6" : "h5"}
                    sx={{ textAlign: "center", color: "text.secondary" }}
                  >
                    {" "}
                    ONE-CLICK CONTENT REUSE
                  </Typography>

                  <Typography
                    variant={isMobile ? "h4" : "h2"}
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                      mb: 1,
                    }}
                  >
                    Build systemic value. Prioritize Impact
                  </Typography>
                  <Typography
                    variant={isMobile ? "body1" : "h5"}
                    sx={{
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    {/* Build systemic value and prioritize impact */}
                  </Typography>
                </Box>
              </FadeInView2>
              <FadeInView2>
                <Typography
                  variant={isMobile ? "body1" : "h5"}
                  sx={{
                    textAlign: "center",
                    color: "text.secondary",
                  }}
                >
                  {" "}
                </Typography>
              </FadeInView2>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView2>
                <Carousel />
              </FadeInView2>
            </Grid>
          </Grid>

          {/* ---------------------END SECTION 4------WHITE------END SOLUTION:USECASE------------------ */}
          {/* ---------------------START SECTION 5------WHERE ALL SURFACES------------------ */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // Adjusted for overall alignment
              justifyContent: "center", // Adjusted for vertical alignment
              width: "100%", // Full width
              //height: "100vh",
            }}
          >
            <FadeInView3 delay={0}>
              <Box sx={{ p: 3, mt: 12 }}>
                <Typography
                  variant={isMobile ? "h6" : "h5"}
                  sx={{ textAlign: "center", color: "text.secondary" }}
                >
                  ON ALL SURFACES
                </Typography>
                <Typography
                  variant={isMobile ? "h4" : "h2"}
                  sx={{
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Stay up to speed wherever you are
                </Typography>
              </Box>
            </FadeInView3>
            <FadeInView3 delay={900}>
              <Typography
                variant={isMobile ? "body1" : "h5"}
                sx={{
                  textAlign: "center",
                  color: "text.secondary",
                }}
              >
                {" "}
              </Typography>
            </FadeInView3>
          </Box>
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 3 : 6 }}>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  position: "relative",
                  height: "auto", // Maintains the container height relative to the viewport
                  paddingTop: "5%",
                  px: "5%",
                }}
              >
                <FadeInView3 delay={100}>
                  <img
                    src="iphone14a.png"
                    alt="iPhone 1"
                    style={{
                      width: "",
                      //paddingRight: "5%",
                      maxWidth: "90%", // Ensure the image is never larger than its container
                      height: "auto", // Maintain aspect ratio

                      zIndex: 1,
                    }}
                  />

                  <img
                    src="iphone14b.png"
                    alt="iPhone 2"
                    style={{
                      //width: "auto",
                      maxWidth: isMobile ? "40%" : "300px", // Ensure the image is never larger than its container
                      height: "auto", // Maintain aspect ratio
                      position: "absolute",
                      right: "30%",
                      transform: "translateX(50%)", // Center horizontally from the right
                      top: isMobile ? "54%" : "50%", // Adjust top position for overlap effect, if desired
                      zIndex: 2,
                    }}
                  />
                </FadeInView3>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={2} sx={{ marginTop: isMobile ? 0 : 21 }}>
                <Grid item xs={12} sm={4} md={4}>
                  <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                    <FadeInView>
                      <Card
                        variant="outlined"
                        sx={{
                          maxWidth: 600,
                          height: "auto",
                          width: "100%",
                          minHeight: isMobile ? "" : "150px",
                          marginBottom: 2,
                          backgroundColor: "#12181f", // Custom background color
                          border: "1px solid #30363d", // Custom border color
                          color: "text.primary", // Ensures text color is from the theme
                          display: "flex", // Ensures the card itself is a flex container
                          flexDirection: "column", // Stacks children vertically
                        }}
                      >
                        <CardContent
                          sx={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "left",
                          }}
                        >
                          <Typography
                            gutterBottom
                            variant={isMobile ? "h6" : "h5"}
                            component="div"
                          >
                            Desktop{" "}
                          </Typography>
                          <Typography
                            variant={isMobile ? "body1" : "h6"}
                            color="text.secondary"
                          >
                            Desktop application for Windows and Mac
                          </Typography>
                        </CardContent>
                      </Card>
                    </FadeInView>
                  </Tilt>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                    <FadeInView>
                      <Card
                        variant="outlined"
                        sx={{
                          maxWidth: 600,
                          height: "auto",
                          minHeight: isMobile ? "" : "150px",
                          width: "100%",
                          marginBottom: 2,
                          backgroundColor: "#12181f", // Custom background color
                          border: "1px solid #30363d", // Custom border color
                          color: "text.primary", // Ensures text color is from the theme
                          display: "flex", // Ensures the card itself is a flex container
                          flexDirection: "column", // Stacks children vertically
                        }}
                      >
                        <CardContent
                          sx={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "left",
                          }}
                        >
                          <Typography
                            gutterBottom
                            variant={isMobile ? "h6" : "h5"}
                            component="div"
                          >
                            Mobile | Tablet | Web
                          </Typography>
                          <Typography
                            variant={isMobile ? "body1" : "h6"}
                            color="text.secondary"
                          >
                            Optimized for mobile and tablet. Accessible from any
                            web browser
                          </Typography>
                        </CardContent>
                      </Card>
                    </FadeInView>
                  </Tilt>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <Tilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
                    <FadeInView>
                      <Card
                        variant="outlined"
                        sx={{
                          maxWidth: 600,
                          height: "auto",
                          minHeight: isMobile ? "" : "150px",
                          width: "100%",
                          marginBottom: 2,
                          backgroundColor: "#12181f", // Custom background color
                          border: "1px solid #30363d", // Custom border color
                          color: "text.primary", // Ensures text color is from the theme
                          display: "flex", // Ensures the card itself is a flex container
                          flexDirection: "column", // Stacks children vertically
                        }}
                      >
                        <CardContent
                          sx={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "left",
                          }}
                        >
                          <Typography
                            gutterBottom
                            variant={isMobile ? "h6" : "h5"}
                            component="div"
                          >
                            Add-ins
                          </Typography>
                          <Typography
                            variant={isMobile ? "body1" : "h6"}
                            color="text.secondary"
                          >
                            Add-ins for Microsoft 365 apps on Windows and Mac
                          </Typography>
                        </CardContent>
                      </Card>
                    </FadeInView>
                  </Tilt>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/*
          <SolutionSection />
          */}
          {/* ---------------------START: How----------------------- */}
          <FadeInView>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "left", // Adjusted for overall alignment
                justifyContent: "center", // Adjusted for vertical alignment
                width: "100%", // Full width
              }}
            >
              <FadeInView3 delay={60}>
                <Box sx={{ p: 3, marginTop: isMobile ? 12 : 26 }}>
                  <Typography
                    variant={isMobile ? "h4" : "h2"}
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    Adapt or work as before
                  </Typography>
                </Box>
              </FadeInView3>
              <FadeInView3 delay={90}>
                <Typography
                  variant={isMobile ? "body1" : "h5"}
                  sx={{
                    textAlign: "center",
                    //color: "text.secondary",
                  }}
                >
                  {" "}
                  DealMaker AI is designed to be a natural extension of your
                  existing workflow. It is not a replacement, but a tool that
                  enhances your current processes
                </Typography>
              </FadeInView3>
            </Box>
          </FadeInView>
          {/* ---------------------How START: IBD centerpoint -- Management, Board, Compliance, Sales&trading, Research, Corporate access, Accounting, research----------------------- */}
          <Grid container spacing={2} sx={{ marginTop: isMobile ? 3 : 9 }}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInView>
                <HowCarousel />
              </FadeInView>
            </Grid>
          </Grid>
          {/*        
          <Grid container spacing={1} sx={{ marginTop: 18, marginBottom: 21 }}>
            <Grid item xs={12} sm={12} md={12}>
              <FadeInViewIBD>
                <IBDFlow />
              </FadeInViewIBD>
            </Grid>
          </Grid>
                */}
          {/* ---------------------START: WHO/ABOUT & INQUIRIES----------------------- */}

          <Grid container spacing={2} sx={{ marginTop: isMobile ? 12 : 26 }}>
            <Grid item xs={12} sm={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left", // Adjusted for overall alignment
                  justifyContent: "center", // Adjusted for vertical alignment
                  width: "100%", // Full width
                  //height: "80vh",
                }}
              >
                <FadeInView3 delay={100}>
                  <Box sx={{ p: 3, mt: 9 }}>
                    <Typography
                      variant={isMobile ? "h4" : "h2"}
                      sx={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      About us
                    </Typography>
                    <Typography
                      variant={isMobile ? "h4" : "h2"}
                      sx={{
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    ></Typography>
                  </Box>
                </FadeInView3>

                <Grid
                  container
                  spacing={2}
                  sx={{
                    marginBottom: 6,
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <Grid item xs={12} sm={12} md={12} sx={{ display: "flex" }}>
                    {/* Tilt, FadeInView components are assumed to be correctly set up */}
                    <Card
                      variant="outlined"
                      sx={{
                        //maxWidth: 600,
                        width: "100%",
                        marginBottom: 2,
                        backgroundColor: "#12181f",
                        border: "1px solid #30363d",
                        color: "text.primary",
                        display: "flex",
                        flexDirection: "column", // Makes content of card stretch to fill available space
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1 }}>
                        {" "}
                        {/* flexGrow ensures the content takes up the maximum space available */}
                        <Typography
                          gutterBottom
                          variant={isMobile ? "h6" : "h5"}
                          component="div"
                        >
                          {/* Title goes here */}
                        </Typography>
                        <Typography
                          variant={isMobile ? "body1" : "h6"}
                          sx={{
                            //color: "text.secondary",
                            transition: "color 1s ease-in-out",
                            "&:hover": {
                              color: "#fff", // Change this color as needed
                            },
                          }}
                        >
                          In 2023, a team of visionaries launched a startup with
                          a clear mission: to improve collaboration within
                          professional services, particularly in the investment
                          banking sector. Our foundation is built on profound
                          industry expertise by a team that have a robust
                          technical background, including years of experience
                          from Microsoft R&D.
                          <br />
                          <br />
                          Our commitment: to create a scalable cloud platform
                          that increase operational efficiency. We are committed
                          to setting new standards for how professionals
                          connect, collaborate, and succeed together with ease.
                          We are driven by experience, guided by vision, and
                          dedicated to providing solutions that shape the future
                          of collaboration by knowledge workers.
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ marginTop: isMobile ? 3 : 9 }}>
            <Grid item xs={12} sm={12} md={12}>
              <Box>
                <Box sx={{ p: 0 }}>
                  <Typography
                    variant={isMobile ? "h4" : "h2"}
                    sx={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    DealMaker AI
                  </Typography>
                </Box>
                <Typography
                  variant={isMobile ? "body1" : "h5"}
                  sx={{
                    textAlign: "center",
                    //color: "text.secondary",
                  }}
                >
                  {" "}
                  Content collaboration and capture of reusable data in
                  real-time, seamlessly integrated with Microsoft 365 apps and
                  services
                </Typography>
                <Grid item xs={12} sm={12} md={12}>
                  <Card
                    variant="outlined"
                    sx={{
                      // maxWidth: 600,
                      mt: 2.5,

                      width: "100%",
                      marginBottom: 2,
                      //backgroundColor: "#0d1117", // Custom background color
                      //border: "1px solid #30363d", // Custom border color
                      color: "text.primary", // Ensures text color is from the theme
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant={isMobile ? "h6" : "h5"}
                        component="div"
                        gutterBottom
                      >
                        Key features and benefits
                      </Typography>
                      <Grid container spacing={2}>
                        {features.map((feature, index) => (
                          <Grid item xs={12} sm={6} key={index}>
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row", // Change to row to place items side by side
                                alignItems: "center", // Center items vertically
                                px: "3px",
                                py: "3px",
                              }}
                            >
                              {isMobile ? (
                                ""
                              ) : (
                                <CheckCircleOutlineOutlined
                                  sx={{ color: "#3fb950", mr: 3 }}
                                />
                              )}{" "}
                              {/* Adjust color as needed */}
                              <ListItemText
                                primary={
                                  <React.Fragment>
                                    <Typography
                                      variant="body1"
                                      component="span"
                                      sx={{ fontWeight: "600" }}
                                    >
                                      {feature.title}:
                                    </Typography>{" "}
                                    {feature.description}
                                  </React.Fragment>
                                }
                              />
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>{" "}
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: 12, mb: 3 }}>
            <Box sx={{ width: "75%" }}>
              <Divider sx={{ color: "text.secondary" }} />
            </Box>
            {/*
            <FadeInView2>
              <Typography
                variant={isMobile ? "body1" : "h6"}
                sx={{
                  textAlign: "center",
                  color: "text.secondary",
                }}
              >
                {" "}
                Insights and feedback
              </Typography>
            </FadeInView2>
            */}
            <FadeInView2>
              <Grid container spacing={0} justifyContent="center">
                {quotes.map((quote, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Box
                      sx={{
                        mt: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: isMobile ? "0" : 2, // Add padding for each box
                        height: "100%", // Ensure box takes full height
                      }}
                    >
                      <Rating name={`rating-${index}`} value={5} readOnly />
                      <Typography
                        component="legend"
                        color="text.secondary"
                        sx={{ textAlign: "center", mt: 1 }}
                      >
                        {`Investment Banker #${index + 1}:`}
                      </Typography>

                      <Box
                        sx={{
                          height: "100px", // Fixed height for the quote to ensure uniformity
                          display: "flex",
                          alignItems: "flex-start", // Center align the text vertically
                          justifyContent: "center", // Center align the text horizontally
                          textAlign: "center", // Ensure text is centered
                          marginBottom: isMobile ? 3 : 6, // Add some space before the legend and rating
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ fontStyle: "italic" }}
                        >
                          {quote}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </FadeInView2>
          </Box>

          <Box sx={{ height: "5vh", mt: 3, mb: isMobile ? 3 : 0 }}>
            <Typography
              variant={isMobile ? "body1" : "h6"}
              sx={{ textAlign: "center" }}
            >
              Inquiries, contact us:{" "}
              <Link href={`mailto:${"contact@softcap.no"}`} style={{}}>
                {"contact@softcap.no"}
              </Link>
            </Typography>
          </Box>

          {/*     
          

          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ mt: "60px" }}
            //style={{ minHeight: "100vh" }} // This makes the Grid container take up the full viewport height
          >
            <Grid item xs={12} sm={12} md={12}>
              <Box
                sx={{
                  width: "100%",
                  alignContent: "center",
                  marginTop: 1,
                  marginBottom: 1,
                  display: "flex", // Use Flexbox
                  flexDirection: "column", // Align children vertically
                  alignItems: "center", // Center children horizontally
                  justifyContent: "center", // Center children vertically
                }}
                ref={bottomRef}
              >
                <SignUpForm onValidSubmission={handleShowConfetti} />
              </Box>
            </Grid>
          </Grid>
             
          {showConfetti && (
            <div
              style={{
                position: "fixed", // Changed from 'absolute' to 'fixed' to position relative to the viewport
                top: 0, // Start from the top of the viewport
                left: 0,
                width: "100%", // Cover the full width
                height: "100%", // Cover the full height
                zIndex: 999999, // Ensure it's on top of other elements
              }}
            >
              <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                //recycle={false}
              />
            </div>
          )}
           */}
        </>
      )}
    </Box>
  );
};

export default AfterVideoSection;
